import {
  useAppDispatch,
  useAppSelector,
  getSportDetailsBySlug,
  setEventType,
  fetchButtonVariables,
  clearExchangeBets,
} from "@hypexone/uicore";
import { useEffect } from "react";
import { useParams, Outlet } from "react-router-dom";
import { websocketService } from "../../../webSocket/SocketServices";

const SportsView = () => {
  const dispatch = useAppDispatch();
  const { topicUrls, betFairWSConnected } = useAppSelector(
    (state) => state.catalog
  );
  const { loggedIn } = useAppSelector((state) => state.auth);

  const pathParams = useParams();

  const eventType = pathParams["eventType"];

  // Keep selected sport in sync with the URL (refresh + client-side navigation)
  useEffect(() => {
    if (eventType) {
      let eventDetails = getSportDetailsBySlug(
        eventType === "horserace" ? "horseracing" : eventType
      );
      if (eventDetails?.id) {
        dispatch(
          setEventType({
            id: eventDetails?.id,
            name: eventDetails?.name,
            slug: eventType,
          })
        );
      }
    }
  }, [eventType, dispatch]);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchButtonVariables());
    }
  }, [loggedIn]);

  // Websocket handler
  useEffect(() => {
    if (loggedIn && topicUrls?.matchOddsBaseUrl) {
      if (betFairWSConnected) {
        websocketService.disconnectToWS();
      }
      const baseUrlsPayload = {
        matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
        bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
        premiumBaseUrl: topicUrls?.premiumBaseUrl,
      };
      websocketService.connectToWS(baseUrlsPayload);

      return () => {
        if (betFairWSConnected) {
          websocketService.disconnectToWS();
        }
      };
    }
  }, [
    loggedIn,
    topicUrls?.matchOddsBaseUrl,
    topicUrls?.bookMakerBaseUrl,
    topicUrls?.premiumBaseUrl,
  ]);

  useEffect(() => {
    dispatch(clearExchangeBets());
  }, []);

  return <Outlet />;
};

export default SportsView;
